import { isPreviewing } from "@builder.io/sdk-react";

import { useIsEditingModel } from "./useIsEditingModel";

// You should use this hook if you want to display a component in normal flow of the application
// and if you want to show it in Builder.io editor only when you are editing the exact model
export function useDisplayModelComponent(
  ...params: Parameters<typeof useIsEditingModel>
) {
  const isEditingModel = useIsEditingModel(...params);

  return isEditingModel === isPreviewing();
}
